// ponytail: Skeleton matching SearchPage layout (map + sidebar) for perceived instant load.
// Falls back to spinner for non-primary pages. Inline styles — zero CSS deps.
export function LoadingFallback() {
  return (
    <div style={{ display: 'flex', height: '100vh', background: '#F9FAFB' }} role="status" aria-label="Loading page">
      {/* Sidebar skeleton */}
      <div style={{ width: '360px', padding: '16px', borderRight: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ height: '40px', borderRadius: '8px', background: '#E5E7EB' }} />
        <div style={{ height: '32px', borderRadius: '6px', background: '#F3F4F6', width: '80%' }} />
        <div style={{ height: '32px', borderRadius: '6px', background: '#F3F4F6', width: '60%' }} />
        <div style={{ flex: 1, borderRadius: '12px', background: '#F3F4F6', marginTop: '8px' }} />
      </div>
      {/* Map skeleton */}
      <div style={{ flex: 1, background: '#E5E7EB', position: 'relative' }}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <div style={{ width: '32px', height: '32px', border: '3px solid #D1D5DB', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
